<script lang="ts">
  import {type Suggestion} from "../../../generated";
  import TrendingQueryIcon from "../../interactive/TrendingQueryIcon.svelte";
  import ArrowRightIcon from "../../interactive/ArrowRightIcon.svelte";
  import {SqrlQaId} from "../../../constants/squirrel";
  import {timeEmptyState} from "../../../times/TimeFactory";
  import {activeIndex} from "../../../store/IndexStore";
  import {SUBMIT_TYPE, submitStore} from "../../../store/SubmitStore";

  export let trendingQuery: Suggestion;
  export let index: number;

  function handleSubmit() {
    timeEmptyState.measure();
    submitStore.handleSubmit(trendingQuery.term, trendingQuery.target, SUBMIT_TYPE.TRENDING_QUERY_ITEM);
  }
</script>

<li class="squirrel_trendingQuery"
    data-qa-id={SqrlQaId.SUGGEST_ITEM}
    data-testid="trending-query-{index}">
    <div class="pl_table-view--item-fully-clickable"
         data-pos={index}
         role="button"
         on:click|preventDefault={handleSubmit}>
        <div class="squirrel_trendingQuery__text js_squirrel_trendingQuery"
             data-qa-id={SqrlQaId.SUGGEST_ROW}>
            <TrendingQueryIcon/>
            <span class="pl_copy100 squirrel_trendingQuery__term js_squirrel_trendingQuery__term"
                  class:squirrel_active={index === $activeIndex}
                  data-target={trendingQuery.target}
                  data-term={trendingQuery.term}>{@html trendingQuery.visual}</span>
            <ArrowRightIcon/>
        </div>
    </div>
</li>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;
  @use "~@otto-ec/global-frontend-settings/scss/font-size" as fonts;
  @use "~@otto-ec/global-frontend-settings/scss/variables" as variables;

  .squirrel_active {
    color: pl_variables.$pl_color-red100;
  }

  .squirrel_trendingQuery {
    position: relative;
    cursor: pointer;
    background-color: white;
    padding: 0 16px;

    &:hover {
      background-color: pl_variables.$pl_color-grey25;
    }

    &:not(:last-child) {
      > div {
        border-bottom: 1px solid pl_variables.$pl_color-grey25;
      }
    }

    &__text {
      @include fonts.font-size(variables.$font100, false);

      padding: 12px 0;
      display: flex;
      height: 48px;

      > .squirrel_trendingQuery__term {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 40px;
      }
    }
  }
</style>
